// extracted by mini-css-extract-plugin
export default {"addToCartControl":"q1-z","giftCard":"r1-z","btnContainer":"s1-z","cartButton":"t1-z","disabled":"u1-z"};